import React from 'react';
import { Box, IconButton, IconChevronLeft24, IconCloseX24, Text } from '@stitch-fix/mode-react';
import { useRouter } from 'next/router';
interface OnboardingNavProps {
  showBackButton?: boolean;
  showCloseButton?: boolean;
  titleColor?: 'blue-45' | 'blue-95' | 'gray-16' | 'white' | 'mint-70';
  backgroundColor?: 'blue-45' | 'blue-95' | 'gray-16' | 'white' | 'mint-70';
  closeButtonColor?: 'blue-45' | 'blue-95' | 'gray-16' | 'white' | 'mint-70';
  onBackClick: () => void;
}
export const OnboardingNav = ({
  showBackButton = true,
  showCloseButton = true,
  titleColor = 'blue-45',
  backgroundColor = 'white',
  closeButtonColor,
  onBackClick
}: OnboardingNavProps) => {
  const router = useRouter();
  return <Box as="header" pt={{
    sm: 1,
    md: 3
  }} pb={1.5} px={0.5} bgColor={backgroundColor} style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '60px',
    flex: '0 0 auto'
  }}>
      <Box style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%'
    }}>
        <Box style={{
        width: '60px',
        display: 'flex',
        justifyContent: 'flex-start'
      }}>
          {showBackButton && <IconButton aria-label="Back" onClick={() => {
          if (onBackClick) {
            onBackClick();
          } else {
            router.back();
          }
        }}>
              <IconChevronLeft24 color={titleColor} title="Back icon" />
            </IconButton>}
        </Box>
        <Text setting="title-small" color={titleColor}>
          Stitch Fix Vision
        </Text>
        <Box style={{
        width: '60px',
        display: 'flex',
        justifyContent: 'flex-end'
      }}>
          {showCloseButton && <IconButton aria-label="Close" onClick={() => {
          router.push('/home');
        }}>
              <IconCloseX24 color={closeButtonColor || titleColor} title="Close icon" />
            </IconButton>}
        </Box>
      </Box>
    </Box>;
};